export default {
    message: 'The {_field_} value must be a phone number.',
    validate: (value) => {
        let regex = /^\+(?:[0-9] ?){6,14}$/;
        return regex.test(value);
    }
}
